import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import classNames from "classnames";

import Gradient from "../Gradient";
import Container from "../Grid/Container";
import Row from "../Grid/Row";
import { mediumAndUp } from "../../theme/mediaQueries";

const GradientBackground = styled(Gradient)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  min-height: 218px;
  max-height: 218px;
`;

const ImageBackground = styled(GradientBackground)`
  background-size: cover;
  background-repeat: no-repeat;
`;

const Wrapper = styled.header`
  width: 100%;
  position: relative;
`;

const ContainerWrapper = styled(Container)`
  padding-top: 60px;
  z-index: 2;
`;

const ContainerRow = styled(Row)`
  align-items: center;
  position: relative;
  z-index: 2;
`;

const ImageWrapper = styled.div`
  ${mediumAndUp`
      padding-top: 60px;
    `};
`;

const ImageHeader = ({
  children,
  stops,
  deg,
  backgroundImage,
  backgroundImageProps,
  withOverlay,
  withOverlayShadow,
  withUnderlay,
  withSpotLight,
  ...props
}) => {
  const {
    style: backgroundImageStyle = {},
    imageRef,
    backgroundRef,
    ...otherBackgroundImageProps
  } = backgroundImageProps;
  return (
    <Wrapper {...props} role="heading" aria-level="1">
      {backgroundImage ? (
        <ImageBackground
          style={{
            ...backgroundImageStyle,
            backgroundImage: withOverlayShadow ? "" : `url(${backgroundImage})`
          }}
          backgroundImage={backgroundImage}
          imageRef={imageRef}
          backgroundRef={backgroundRef}
          {...otherBackgroundImageProps}
          className={classNames({
            "gradient--overlay": !withSpotLight && withOverlay,
            "gradient--overlay-shadow": withOverlayShadow,
            "gradient--spotlight": withSpotLight,
            "gradient--underlay": withUnderlay
          })}
          aria-hidden
        />
      ) : (
        <GradientBackground
          stops={stops}
          deg={deg}
          className={classNames({
            "gradient--overlay": !withSpotLight && withOverlay,
            "gradient--spotlight": withSpotLight,
            "gradient--underlay": !withSpotLight && withUnderlay
          })}
          style={backgroundImageStyle}
        />
      )}
      <ContainerWrapper>
        <ContainerRow>{children}</ContainerRow>
      </ContainerWrapper>
    </Wrapper>
  );
};

ImageHeader.propTypes = {
  ...Gradient.propTypes,
  backgroundImage: PropTypes.string,
  backgroundImageProps: PropTypes.objectOf(PropTypes.any),
  withOverlay: PropTypes.bool,
  withOverlayShadow: PropTypes.bool,
  withUnderlay: PropTypes.bool,
  withSpotLight: PropTypes.bool
};

ImageHeader.defaultProps = {
  backgroundImage: null,
  backgroundImageProps: {},
  withOverlay: false,
  withOverlayShadow: false,
  withUnderlay: false,
  withSpotLight: false
};

ImageHeader.ImageWrapper = ImageWrapper;

export default ImageHeader;
